import { render } from "./WelcomeCard.vue?vue&type=template&id=775d2bf5&scoped=true"
import script from "./WelcomeCard.vue?vue&type=script&lang=js"
export * from "./WelcomeCard.vue?vue&type=script&lang=js"

import "./WelcomeCard.vue?vue&type=style&index=0&id=775d2bf5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Shavin\\Documents\\apps\\10-candles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775d2bf5"]])

export default __exports__